/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const RealtimeStreamReady = zod.object({
  version: zod.literal(1),
  resources: zod.array(zod.string().min(1)).min(1),
});

export type RealtimeStreamReady = zod.input<typeof RealtimeStreamReady>;
export type RealtimeStreamReadyOutput = zod.output<typeof RealtimeStreamReady>;
